<div *ngIf="currentEnv == 'emvs'">
  <div class="page__content">
    <div class="content__inner">
      <div class="register-form">
        <div class="row">
          <div class="col-sm-12">
            <h5 id="solicitud-titulo">{{procedimiento.nombre}}
            </h5>
          </div>
        </div>

        <ul class="nav nav-tabs nav-stepper" id="myTab" role="tablist">
          <li class="nav-item">
            <a [ngClass]="esNavegable('personales-tab')" class="active" id="personales-tab" data-toggle="tab"
              href="#personales" role="tab" aria-controls="home" aria-selected="true"
              (click)="restauraPestaniaSeleccionada('personales-tab')">
              <span>{{ 'TRAMITE.TABS.APPLICANT_DATA' | translate }}</span>
            </a>
          </li>
          <li class="nav-item">
            <a [ngClass]="esNavegable('circunstancias-tab')" id="circunstancias-tab" data-toggle="tab"
              href="#circunstancias" role="tab" aria-controls="profile"
              (click)="restauraPestaniaSeleccionada('circunstancias-tab')">{{ 'TRAMITE.TABS.ECONOMIC_CIRCUMSTANCES' | translate }}</a>
          </li>
          <li class="nav-item">
            <a [ngClass]="esNavegable('unidad-tab')" id="unidad-tab" data-toggle="tab" href="#unidad" role="tab"
              aria-controls="contact" (click)="restauraPestaniaSeleccionada('unidad-tab')">{{ 'TRAMITE.TABS.FAMILY_UNIT' | translate }}</a>
          </li>
          <li class="nav-item">
            <a [ngClass]="esNavegable('consulta-tab')" id="consulta-tab" data-toggle="tab" href="#consulta" role="tab"
              aria-controls="contact" aria-selected="false"
              (click)="restauraPestaniaSeleccionada('consulta-tab')">{{ 'TRAMITE.TABS.RESPONSIBLE_DECLARATION' | translate }}</a>
          </li>
          <li class="nav-item">
            <a [ngClass]="esNavegable('autorizacion-tab')" id="autorizacion-tab" data-toggle="tab" href="#autorizacion"
              role="tab" aria-controls="contact" aria-selected="false"
              (click)="restauraPestaniaSeleccionada('autorizacion-tab')">{{ 'TRAMITE.TABS.DATA_AUTHORIZATION' | translate }}</a>
          </li>







        </ul>
        <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate"
          [fullScreen]="true" [name]="'tramite_spv_spinner'">
          <p style="color: white">{{mensajeSpinner}}</p>
        </ngx-spinner>
        <div class="tab-content" id="myTabContent">

          <div class="tab-pane fade show active" id="personales" role="tabpanel" aria-labelledby="personales-tab">


            <div>

              <h3 class="tabtitle">{{ 'TRAMITE.TITLES.PERSONAL_DATA_NOTIFICATIONS' | translate }}</h3>
              <div class="row mt-3">
                <div class="col-sm-4 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.N_DE_DOCUMENTO' | translate }}</label>
                  <input type="text" id="numero_documento" name="numero_documento"
                    [ngModel]="this.currentUser.numero_documento" class="form-control" disabled />
                </div>
                <div class="col-sm-4 spacing-box" *ngIf="this.currentUser.tipopersona.id == 1">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.APELLIDOS' | translate }}</label>
                  <input type="text" id="apellido" name="apellido"
                    [ngModel]="this.currentUser.apellido1 + ' ' +this.currentUser.apellido2" class="form-control"
                    disabled>
                </div>
                <div class="col-sm-4 spacing-box">
                  <label class="tinyLabel">{{ (this.currentUser.tipopersona.id == 1 ? 'TRAMITE.FORM.LABEL.NOMBRE' : 'TRAMITE.FORM.LABEL.RAZON_SOCIAL') | translate }}</label>
                  <input type="text" id="nombre" name="nombre" [ngModel]="this.currentUser.nombre" class="form-control"
                    disabled />
                </div>
                <div class="col-sm-2 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TIPO_DE_VIA' | translate }}</label>
                  <input type="text" id="tipovia" name="tipovia" [ngModel]="this.activeAddress.type_of_road.tipovia"
                    class="form-control" disabled>
                </div>
                <div class="col-sm-8 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.DIRECCION' | translate }}</label>
                  <input type="text" id="name_road" name="name_road"
                    [ngModel]="this.activeAddress.name_road + ' ' + this.activeAddress.number_road" class="form-control"
                    disabled>
                </div>

                <div *ngIf="activeAddress.block" class="col-sm-2 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PORTAL' | translate }}</label>
                  <input type="text" id="block" name="block" [ngModel]="this.activeAddress.block" class="form-control"
                    disabled>
                </div>

                <div *ngIf="activeAddress.stairs" class="col-sm-2 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.ESCALERA' | translate }}</label>
                  <input type="text" id="stairs" name="stairs" [ngModel]="this.activeAddress.stairs"
                    class="form-control" disabled>
                </div>

                <div *ngIf="activeAddress.floor" class="col-sm-2 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PLANTA' | translate }}</label>
                  <input type="text" id="floor" name="floor" [ngModel]="this.activeAddress.floor" class="form-control"
                    disabled>
                </div>

                <div *ngIf="activeAddress.door" class="col-sm-2 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PUERTA' | translate }}</label>
                  <input type="text" id="door" name="door" [ngModel]="this.activeAddress.door" class="form-control"
                    disabled>
                </div>
                <div class="col-sm-2 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.CODIGO_POSTAL' | translate }}</label>
                  <input type="text" id="postal_code" name="postal_code" [ngModel]="this.activeAddress.postal_code"
                    class="form-control" disabled />
                </div>
                <div class="col-sm-4 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PROVINCIA' | translate }}</label>
                  <input class="w-100 form-control" id="province" name="province"
                    [ngModel]="activeAddress.province.nombre" disabled />
                </div>
                <div class="col-sm-4 spacing-box">
                  <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.MUNICIPIO' | translate }}</label>
                  <input class="w-100 form-control" id="nameMunicipality" name="nameMunicipality"
                    [ngModel]="municipioNombre" disabled />
                </div>
                <div class="col-sm-4 spacing-box">
                  <div class="form-group">
                    <label class="tinyLabel">{{ 'PLACEHOLDER.EMAIL' | translate }}</label>
                    <input type="text" id="email" name="email" [ngModel]="this.currentUser.email" class="form-control"
                      disabled />
                  </div>
                </div>
                <div class="col-sm-4 spacing-box">
                  <div class="form-group">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TELEFONO_1' | translate }}</label>
                    <input type="text" id="telefono" name="telefono" [ngModel]="this.currentUser.telefono"
                      class="form-control" disabled />
                  </div>
                </div>
                <div class="w-100 mlr-14px">
                  <form [formGroup]="formTramite" (ngSubmit)="onSubmitTramite()" class=" row">
                    <div class="col-sm-4 spacing-box">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TELEFONO_2' | translate }}</label>
                      <input type="text" id="telefono2" name="telefono2"
                        [ngClass]="{'is-invalid': submitted && this.formTramite.controls['telefono2'].errors}"
                        class="form-control" formControlName="telefono2" />
                      <mat-error *ngIf="this.formTramite.get('telefono2')?.hasError('pattern')">{{ 'TRAMITE.ERROR.PHONE_FORMAT' | translate }}
                        no es correcto</mat-error>
                    </div>
                    <div class="col-sm-4 spacing-box">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TELEFONO_3' | translate }}</label>
                      <input type="text" id="telefono3" name="telefono3"
                        [ngClass]="{'is-invalid': submitted && this.formTramite.controls['telefono3'].errors}"
                        class="form-control" formControlName="telefono3" />
                      <mat-error *ngIf="this.formTramite.get('telefono3')?.hasError('pattern')">{{ 'TRAMITE.ERROR.PHONE_FORMAT' | translate }}
                        no es correcto</mat-error>
                    </div>
                    <div class="col-sm-4 spacing-box" *ngIf="this.currentUser.tipopersona.id == 1">
                      <div class="spacing-box">
                        <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                          <label>{{ 'TRAMITE.FORM.LABEL.GENERO' | translate }}</label>
                          <div class="form-check form-check-inline">
                            <input [ngClass]="{'checkDisabled': currentUser.genero != null}"
                              class="form-check-input radio-personalice" type="radio" formControlName="genero"
                              id="inlineRadio1" value="Hombre">
                            <label class="form-check-label" for="inlineRadio1"
                              [ngClass]="{'invalid-file': submitted && formTramite.controls['genero'].errors}">{{ 'TRAMITE.FORM.LABEL.HOMBRE' | translate }}</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input [ngClass]="{'checkDisabled': currentUser.genero != null}"
                              class="form-check-input radio-personalice" type="radio" formControlName="genero"
                              id="inlineRadio2" value="Mujer">
                            <label class="form-check-label" for="inlineRadio2"
                              [ngClass]="{'invalid-file': submitted && formTramite.controls['genero'].errors}">{{ 'TRAMITE.FORM.LABEL.MUJER' | translate }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-100 spacing-box gap-2 d-md-flex justify-content-md-end btn-form-pad">
                      <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                      <button type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>
                      <button type="submit" class="btn btn-primary mt-2" id="siguiente2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>





          <div class="tab-pane fade" id="circunstancias" role="tabpanel" aria-labelledby="circunstancias-tab">
            <form [formGroup]="formCircunstancias" (ngSubmit)="onSubmitCircunstancias()">
              <h3 class="tabtitle">{{ 'TRAMITE.TITLES.ECONOMIC_FAMILY_PERSONAL' | translate }}</h3>
              <div class="row mt-3" *ngIf="procedimiento.link_ayuda">
                <div class="col-sm-12">
                  <span class="manual-help activo"><a class="icons-tramite"
                      href="{{procedimiento.link_ayuda}}"
                      target="_blank"><img class="activo" src="assets/reading-book.png" width="25px"
                        title="Manual de Ayuda" />{{ 'TRAMITE.CONTENT.MANUAL_DE_AYUDA_PARA_CUMPLIMENTAR_EL_FORMULARIO' | translate }}</a></span>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.1_ESTA_EMPADRONADO_ININTERRUMPIDAMENTE_EN_EL_MUNICIPIO_DE_MADRID_CON_UNA_ANTIGUE' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta1" id="inlineRadioPregunta1si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta1si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta1" id="inlineRadioPregunta1no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta1no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.2_SU_EDAD_SE_ENCUENTRA_COMPRENDIDA_ENTRE_LOS_18_Y_50_ANOS_A_FECHA_DE_CIERRE_DEL_' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta2" id="inlineRadioPregunta2si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta2si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta2" id="inlineRadioPregunta2no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta2no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.3_USTED_O_ALGUN_MIEMBRO_DE_SU_UNIDAD_FAMILIAR_TIENE_MOVILIDAD_REDUCIDA_PERMANENT' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta3" id="inlineRadioPregunta3si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta3si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta3" id="inlineRadioPregunta3no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta3no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>4.	¿Es usted miembro de una familia numerosa? <sup class="indicador-nota">i</sup> </p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta4" id="inlineRadioPregunta4si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta4si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta4" id="inlineRadioPregunta4no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta4no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.5_USTED_O_ALGUN_MIEMBRO_DE_SU_UNIDAD_FAMILIAR_HA_SIDO_CONDENADO_MEDIANTE_SENTENC' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta5" id="inlineRadioPregunta5si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta5si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta5" id="inlineRadioPregunta5no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta5no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>

              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.6_USTED_O_ALGUN_MIEMBRO_DE_SU_UNIDAD_FAMILIAR_HA_SIDO_CONDENADO_MEDIANTE_SENTENC' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta6" id="inlineRadioPregunta6si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta6si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta6" id="inlineRadioPregunta6no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta6no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>

              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.7_LOS_INGRESOS_DE_TODA_SU_UNIDAD_FAMILIAR_EN_EL_ANO_2025_ESTUVIERON_COMPRENDIDOS' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta7" id="inlineRadioPregunta7si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta7si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta7" id="inlineRadioPregunta7no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta7no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>

              </div>                            
              <div class="w-100 d-flex">
                <div class="w80">
                  <p class="nota-aclaratoria">{{ 'TRAMITE.CONTENT.LOS_INGRESOS_REFLEJADOS_EN_LA_SIGUIENTE_TABLA_SON_UNA_ESTIMACION_DEL_UMBRAL_DE_I' | translate }}</p>
                </div>
              </div>
              <div class="w-100 d-flex">
                <!-- Tabla informativa de ingresos familiares -->
                <div class="tabla-ingresos">
                  <!-- Encabezados -->
                  <div class="tabla-ingresos__header-group">
                    <div class="tabla-ingresos__header-left">
                      <div class="tabla-ingresos__cell tabla-ingresos__cell--header-col">{{ 'TRAMITE.CONTENT.INGRESOS_FAMILIARES' | translate }}</div>
                    </div>
                    <div class="tabla-ingresos__header-right">
                      <div class="tabla-ingresos__header-titles">
                        <div class="tabla-ingresos__cell">{{ 'TRAMITE.CONTENT.1_O_2_MIEMBROS' | translate }}</div>
                        <div class="tabla-ingresos__cell">{{ 'TRAMITE.CONTENT.3_MIEMBROS' | translate }}</div>
                        <div class="tabla-ingresos__cell">{{ 'TRAMITE.CONTENT.4_MIEMBROS' | translate }}</div>
                        <div class="tabla-ingresos__cell">{{ 'TRAMITE.CONTENT.5_MIEMBROS' | translate }}</div>
                      </div>
                      <div class="tabla-ingresos__header-subtitles">
                        <div class="tabla-ingresos__cell tabla-ingresos__cell--subheader">{{ 'TRAMITE.CONTENT.BRUTOS_ANUALES' | translate }}</div>
                        <div class="tabla-ingresos__cell tabla-ingresos__cell--subheader">{{ 'TRAMITE.CONTENT.BRUTOS_ANUALES' | translate }}</div>
                        <div class="tabla-ingresos__cell tabla-ingresos__cell--subheader">{{ 'TRAMITE.CONTENT.BRUTOS_ANUALES' | translate }}</div>
                        <div class="tabla-ingresos__cell tabla-ingresos__cell--subheader">{{ 'TRAMITE.CONTENT.BRUTOS_ANUALES' | translate }}</div>
                      </div>
                    </div>
                  </div>
                  <!-- Fila 3,50 veces el IPREM -->
                  <div class="tabla-ingresos__row">
                    <div class="tabla-ingresos__cell tabla-ingresos__cell--header-col">{{ 'TRAMITE.CONTENT.3_50_VECES_EL_IPREM' | translate }}</div>
                    <div class="tabla-ingresos__cell">{{ 'TRAMITE.CONTENT.41_434_99' | translate }}</div>
                    <div class="tabla-ingresos__cell">{{ 'TRAMITE.CONTENT.42_650_34' | translate }}</div>
                    <div class="tabla-ingresos__cell">{{ 'TRAMITE.CONTENT.44_392_78' | translate }}</div>
                    <div class="tabla-ingresos__cell">{{ 'TRAMITE.CONTENT.46_793_59' | translate }}</div>
                  </div>
                  <!-- Fila 4,00 veces el IPREM -->
                  <div class="tabla-ingresos__row">
                    <div class="tabla-ingresos__cell tabla-ingresos__cell--header-col">{{ 'TRAMITE.CONTENT.4_00_VECES_EL_IPREM' | translate }}</div>
                    <div class="tabla-ingresos__cell">{{ 'TRAMITE.CONTENT.47_048_76' | translate }}</div>
                    <div class="tabla-ingresos__cell">{{ 'TRAMITE.CONTENT.48_437_73' | translate }}</div>
                    <div class="tabla-ingresos__cell">{{ 'TRAMITE.CONTENT.50_429_10' | translate }}</div>
                    <div class="tabla-ingresos__cell">{{ 'TRAMITE.CONTENT.53_172_88' | translate }}</div>
                  </div>
                  <!-- Fila 5,50 veces el IPREM -->
                  <div class="tabla-ingresos__row">
                    <div class="tabla-ingresos__cell tabla-ingresos__cell--header-col">{{ 'TRAMITE.CONTENT.5_50_VECES_EL_IPREM' | translate }}</div>
                    <div class="tabla-ingresos__cell">{{ 'TRAMITE.CONTENT.63_890_08' | translate }}</div>
                    <div class="tabla-ingresos__cell">{{ 'TRAMITE.CONTENT.65_799_92' | translate }}</div>
                    <div class="tabla-ingresos__cell">{{ 'TRAMITE.CONTENT.68_538_04' | translate }}</div>
                    <div class="tabla-ingresos__cell">{{ 'TRAMITE.CONTENT.72_310_74' | translate }}</div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p>{{ 'TRAMITE.CONTENT.8_USTED_O_ALGUN_MIEMBRO_DE_SU_UNIDAD_FAMILIAR_PERCIBEN_ALGUN_TIPO_DE_RENTA_EXENT' | translate }}</p>
                </div>
                <div class="w-25">
                  <div class="d-flex mt-2 form-check form-check-inline justify-content-around w-100">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta8" id="inlineRadioPregunta8si" value="Sí">
                      <label class="form-check-label" for="inlineRadioPregunta8si">{{ 'TRAMITE.FORM.LABEL.SI' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input radio-personalice" type="radio" formControlName="pregunta8" id="inlineRadioPregunta8no" value="No">
                      <label class="form-check-label" for="inlineRadioPregunta8no">{{ 'TRAMITE.FORM.LABEL.NO' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p class="nota-aclaratoria">{{ 'TRAMITE.CONTENT.LAS_RENTAS_EXENTAS_SON_AQUELLAS_QUE_NO_ESTAN_SOMETIDAS_A_GRAVAMEN_DEL_IRPF_ENTRE' | translate }}</p>
                  <ul class="lista-rentas-exentas">
                    <li>{{ 'TRAMITE.CONTENT.LAS_PRESTACIONES_RECONOCIDAS_AL_CONTRIBUYENTE_POR_LA_SEGURIDAD_SOCIAL_O_POR_LAS_' | translate }}</li>
                    <li>{{ 'TRAMITE.CONTENT.LAS_PRESTACIONES_Y_AYUDAS_FAMILIARES_PERCIBIDAS_DE_CUALQUIERA_DE_LAS_ADMINISTRAC' | translate }}</li>
                    <li>{{ 'TRAMITE.CONTENT.LA_PRESTACION_DE_LA_SEGURIDAD_SOCIAL_DEL_INGRESO_MINIMO_VITAL_EN_EL_QUE_ESTA_INC' | translate }}</li>
                    <li>{{ 'TRAMITE.CONTENT.LA_PRESTACION_PUBLICA_POR_ORFANDAD' | translate }}</li>
                  </ul>
                </div>
              </div>
              <div class="w-100 d-flex">
                <div class="w80">
                  <p class="nota-aclaratoria"> <sup class="indicador-nota">i</sup> Definición familia numerosa: la que haya obtenido y mantenga vigente el título de familia numerosa y se presenten en la solicitud, al menos en un número suficiente de miembros como para obtener el mencionado título.</p>
                </div>                
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                    <button type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>
                    <button type="submit" class="btn btn-primary m-right mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="tab-pane fade" id="unidad" role="tabpanel" aria-labelledby="unidad-tab">
            <form [formGroup]="formUnidadFamiliar" (ngSubmit)="onSubmitUnidadFamiliar()">
              <h3 class="tabtitle">{{ 'TRAMITE.TITLES.FAMILY_UNIT_DATA' | translate }}</h3>
              <div class="row mt-3" *ngIf="procedimiento.link_ayuda">
                <div class="col-sm-12">
                  <span class="manual-help activo"><a class="icons-tramite"
                        href="{{procedimiento.link_ayuda}}"
                        target="_blank"><img class="activo" src="assets/reading-book.png" width="25px"
                        title="Manual de Ayuda" />{{ 'TRAMITE.CONTENT.MANUAL_DE_AYUDA_PARA_CUMPLIMENTAR_EL_FORMULARIO' | translate }}</a></span>
                </div>
              </div>
              <div formArrayName="familiar">
                <div class="familiar-accordion">
                  <div class="familiar-card"
                       *ngFor="let passengerGroup of familiar?.controls; let i = index"
                       [class.is-active]="familiarActivo === i"
                       [class.has-errors]="submitFamiliar && familiar.controls[i].invalid"
                       [formGroupName]="i">
                    <button type="button" class="familiar-card__header" (click)="toggleFamiliar(i)"
                            [attr.aria-expanded]="familiarActivo === i">
                      <span class="familiar-card__index">{{ i + 1 }}</span>
                      <span class="familiar-card__summary">
                        <strong>{{ passengerGroup.get('nombre')?.value || passengerGroup.get('primerApellido')?.value
                          ? (passengerGroup.get('nombre')?.value + ' ' + (passengerGroup.get('primerApellido')?.value || '')).trim()
                          : 'Familiar sin completar' }}</strong>
                        <small>
                          <ng-container *ngIf="passengerGroup.get('parentesco')?.value">{{ passengerGroup.get('parentesco')?.value }}</ng-container>
                          <ng-container *ngIf="passengerGroup.get('parentesco')?.value && passengerGroup.get('documento')?.value"> · </ng-container>
                          <ng-container *ngIf="passengerGroup.get('documento')?.value">{{ passengerGroup.get('documento')?.value }}</ng-container>
                        </small>
                      </span>
                      <span class="familiar-card__chevron" aria-hidden="true">▾</span>
                    </button>
                    <div class="familiar-card__body" *ngIf="familiarActivo === i">
                      <div class="familiar-field">
                        <label>{{ 'TRAMITE.FORM.LABEL.DNI_NIE' | translate }}</label>
                        <input type="text"
                               [readonly]="i == 0 && passengerGroup.get('documento')?.value == this.numerodocumento && passengerGroup.get('documento')?.value ? 'true' : null"
                               formControlName="documento" class="form-control"
                               [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('documento').errors}">
                      </div>
                      <div class="familiar-field">
                        <label>{{ 'PROCEDIMIENTO.EDIT.NAME' | translate }}</label>
                        <input type="text"
                               [readonly]="i == 0 && passengerGroup.get('documento')?.value == this.numerodocumento && passengerGroup.get('nombre')?.value ? 'true' : null"
                               formControlName="nombre" class="form-control"
                               [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('nombre').errors}">
                      </div>
                      <div class="familiar-field">
                        <label>{{ 'TRAMITE.FORM.LABEL.APELLIDO_1' | translate }}</label>
                        <input type="text"
                               [readonly]="i == 0 && passengerGroup.get('documento')?.value == this.numerodocumento && passengerGroup.get('primerApellido')?.value ? 'true' : null"
                               formControlName="primerApellido" class="form-control"
                               [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('primerApellido').errors}">
                      </div>
                      <div class="familiar-field">
                        <label>{{ 'TRAMITE.FORM.LABEL.APELLIDO_2' | translate }}</label>
                        <input type="text"
                               [readonly]="i == 0 && passengerGroup.get('documento')?.value == this.numerodocumento && passengerGroup.get('segundoApellido')?.value ? 'true' : null"
                               formControlName="segundoApellido" class="form-control"
                               [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('segundoApellido').errors}">
                      </div>
                      <div class="familiar-field">
                        <label>{{ 'TRAMITE.FORM.LABEL.FECHA_DE_NACIMIENTO' | translate }}</label>
                        <input type="date" formControlName="fecha_nacimiento" class="form-control"
                               [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('fecha_nacimiento').errors}">
                      </div>
                      <div class="familiar-field">
                        <label>{{ 'TRAMITE.FORM.LABEL.PARENTESCO' | translate }}</label>
                        <mat-select formControlName="parentesco" class="form-control"
                                    [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('parentesco').errors, 'readonly-wrapper': i == 0 && passengerGroup.get('documento')?.value == this.numerodocumento && passengerGroup.get('parentesco')?.value}">
                          <ng-container *ngFor="let parentesco of parentescos">
                            <mat-option
                              *ngIf="(i == 0 && passengerGroup.get('documento')?.value == this.numerodocumento && parentesco == 'SOLICITANTE') || (i != 0 && parentesco != 'SOLICITANTE')"
                              [value]="parentesco">{{ parentesco }}</mat-option>
                          </ng-container>
                        </mat-select>
                      </div>
                      <div class="familiar-field">
                        <label>{{ 'TRAMITE.FORM.LABEL.ESTADO_CIVIL' | translate }}</label>
                        <mat-select formControlName="estado_civil" class="form-control"
                                    [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('estado_civil').errors}">
                          <mat-option *ngFor="let estado of estadosCiviles" [value]="estado.id">{{ estado.nombre }}</mat-option>
                        </mat-select>
                      </div>
                      <div class="familiar-field">
                        <label>{{ 'TRAMITE.FORM.LABEL.GRADO_DE_DISCAPACIDAD' | translate }}</label>
                        <mat-select formControlName="grado_discapacidad" class="form-control"
                                    [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('grado_discapacidad').errors}">
                          <mat-option *ngFor="let grado of gradosDiscapacidad" [value]="grado.id">{{ grado.nombre }}</mat-option>
                        </mat-select>
                      </div>
                      <div class="familiar-field">
                        <label>{{ 'TRAMITE.FORM.LABEL.GRADO_DE_DEPENDENCIA' | translate }}</label>
                        <mat-select formControlName="grado_dependencia" class="form-control"
                                    [ngClass]="{'is-invalid': submitFamiliar && familiar.controls[i].get('grado_dependencia').errors}">
                          <mat-option *ngFor="let grado of gradosDependencia" [value]="grado.id">{{ grado.nombre }}</mat-option>
                        </mat-select>
                      </div>
                      <div class="familiar-field familiar-field--actions" *ngIf="i > 0">
                        <button type="button" (click)="deleteFamiliar(i)" class="btn btn-danger">{{ 'TRAMITE.FAMILY.DELETE' | translate }}</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="w-100 d-flex spacing-box">
                  <div class="w80">
                    <ul class="lista-rentas-exentas">
                      <li>{{ 'TRAMITE.CONTENT.DEBEN_FIGURAR_EN_LA_ANTERIOR_TABLA_TODOS_LOS_MIEMBROS_DE_LA_UNIDAD_FAMILIAR_CON_' | translate }}</li>
                      <li>{{ 'TRAMITE.CONTENT.EN_LA_COLUMNA_DE_GRADO_DE_DISCAPACIDAD_INDIQUE_EL_PORCENTAJE_QUE_TIENE' | translate }}</li>
                      <li>{{ 'TRAMITE.CONTENT.EN_LA_COLUMNA_DE_GRADO_DE_DEPENDENCIA_INDIQUE_SI_TIENE_GRADO_I_GRADO_II_O_GRADO_' | translate }}</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 pt-2">
                <div class="form-group">
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="button" (click)="addFamiliar()" class="btn btn-primary">{{ 'TRAMITE.CONTENT.ANADIR_FAMILIAR' | translate }}</button>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 pt-2">
                <div class="form-group">
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                    <button type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>
                    <button type="submit" class="btn btn-primary mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="tab-pane fade" id="autorizacion" role="tabpanel" aria-labelledby="autorizacion-tab">
            <form [formGroup]="formAutorizacion" (ngSubmit)="onSubmitAutorizacionCheck()">
              <h3 class="tabtitle">{{ 'TRAMITE.TITLES.DATA_AUTHORIZATION_PUBLIC' | translate }}</h3>
              <div class="row mt-3" *ngIf="procedimiento.link_ayuda">
                <div class="col-sm-12">
                  <span class="manual-help activo"><a class="icons-tramite"
                      href="{{procedimiento.link_ayuda}}"
                      target="_blank"><img class="activo" src="assets/reading-book.png" width="25px"
                        title="Manual de Ayuda" />{{ 'TRAMITE.CONTENT.MANUAL_DE_AYUDA_PARA_CUMPLIMENTAR_EL_FORMULARIO' | translate }}</a></span>
                </div>
              </div>

              <div formArrayName="autorizacion">
                <div class="familiar-accordion familiar-accordion--readonly" *ngIf="lastVisitedTab == 'autorizacion-tab'">
                  <ng-container *ngFor="let passengerGroup of autorizacion?.controls; let i = index">
                    <div class="familiar-card"
                         *ngIf="passengerGroup.get('fecha_nacimiento')?.value ? esMayorEdad(passengerGroup.get('fecha_nacimiento').value) : false"
                         [class.is-active]="autorizacionActivo === i"
                         [formGroupName]="i">
                      <button type="button" class="familiar-card__header" (click)="toggleAutorizacion(i)"
                              [attr.aria-expanded]="autorizacionActivo === i">
                        <span class="familiar-card__index">{{ i + 1 }}</span>
                        <span class="familiar-card__summary">
                          <strong>{{ (passengerGroup.get('nombre')?.value + ' ' + (passengerGroup.get('primerApellido')?.value || '')).trim() || 'Sin nombre' }}</strong>
                          <small>
                            <ng-container *ngIf="passengerGroup.get('parentesco')?.value">{{ passengerGroup.get('parentesco')?.value }}</ng-container>
                            <ng-container *ngIf="passengerGroup.get('parentesco')?.value && passengerGroup.get('documento')?.value"> · </ng-container>
                            <ng-container *ngIf="passengerGroup.get('documento')?.value">{{ passengerGroup.get('documento')?.value }}</ng-container>
                          </small>
                        </span>
                        <span class="familiar-card__check"
                              [class.is-checked]="passengerGroup.get('send_request_accept')?.value">
                          <ng-container *ngIf="passengerGroup.get('send_request_accept')?.value">✓ Autorizado</ng-container>
                          <ng-container *ngIf="!passengerGroup.get('send_request_accept')?.value">{{ 'TRAMITE.TEXT.NOT_AUTHORIZED' | translate }}</ng-container>
                        </span>
                        <span class="familiar-card__chevron" aria-hidden="true">▾</span>
                      </button>
                      <div class="familiar-card__body" *ngIf="autorizacionActivo === i">
                        <div class="familiar-field familiar-field--readonly">
                          <label>{{ 'TRAMITE.FORM.LABEL.DNI_NIE' | translate }}</label>
                          <span class="familiar-field__value">{{ passengerGroup.get('documento')?.value || '—' }}</span>
                        </div>
                        <div class="familiar-field familiar-field--readonly">
                          <label>{{ 'PROCEDIMIENTO.EDIT.NAME' | translate }}</label>
                          <span class="familiar-field__value">{{ passengerGroup.get('nombre')?.value || '—' }}</span>
                        </div>
                        <div class="familiar-field familiar-field--readonly">
                          <label>{{ 'TRAMITE.FORM.LABEL.APELLIDO_1' | translate }}</label>
                          <span class="familiar-field__value">{{ passengerGroup.get('primerApellido')?.value || '—' }}</span>
                        </div>
                        <div class="familiar-field familiar-field--readonly">
                          <label>{{ 'TRAMITE.FORM.LABEL.APELLIDO_2' | translate }}</label>
                          <span class="familiar-field__value">{{ passengerGroup.get('segundoApellido')?.value || '—' }}</span>
                        </div>
                        <div class="familiar-field familiar-field--readonly">
                          <label>{{ 'TRAMITE.FORM.LABEL.FECHA_DE_NACIMIENTO' | translate }}</label>
                          <span class="familiar-field__value">{{ (passengerGroup.get('fecha_nacimiento')?.value | date:'dd/MM/yyyy') || '—' }}</span>
                        </div>
                        <div class="familiar-field familiar-field--readonly">
                          <label>{{ 'TRAMITE.FORM.LABEL.ESTADO_CIVIL' | translate }}</label>
                          <span class="familiar-field__value">{{ passengerGroup.get('estado_civil')?.value || '—' }}</span>
                        </div>
                        <div class="familiar-field familiar-field--readonly">
                          <label>{{ 'TRAMITE.FORM.LABEL.PARENTESCO' | translate }}</label>
                          <span class="familiar-field__value">{{ passengerGroup.get('parentesco')?.value || '—' }}</span>
                        </div>
                        <label class="familiar-field__checkbox">
                          <input type="checkbox" formControlName="send_request_accept">
                          <span>{{ 'TRAMITE.TEXT.AUTHORIZE_QUERY' | translate }}</span>
                        </label>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div class="row  p-2" style="margin-top: 25px;">
                <p class="smallInfo font1rem">Esta autorización deberá ir <strong>{{ 'TRAMITE.CONTENT.FIRMADA_POR_TODOS_LOS_MAYORES_DE_18_ANOS' | translate }}</strong>: Tras el envío firmado de este trámite por usted como solicitante, el resto de
                  personas tendrán una notificación en la Oficina Virtual que podrán firmar digitalmente a través de sus
                  propias cuentas de usuario (deberán registrarse en la oficina si no lo han hecho previamente).</p>
                <p class="smallInfo font1rem"> <strong>La presente solicitud de inscripción en la {{procedimiento.nombre}} no se dará por finalizada hasta que todas las personas mayores de 18 años incluidas en
                    la unidad familiar realicen su correspondiente firma.</strong></p>
                <p class="smallInfo font1rem">
                  <strong>{{ 'TRAMITE.CONTENT.EN_CASO_DE_NO_AUTORIZAR_A_REALIZAR_LA_CONSULTA_DE_DATOS_EL_SOLICITANTE_DEBERA_AP' | translate }}</strong> 
                  Asimismo, los interesados serán responsables de la veracidad de los datos y documentos presentados, pudiendo 
                  iniciarse las acciones correspondientes en caso de detectarse falsedad, inexactitud u ocultación de información.

                </p>
              </div>
              <div class="row p-2">
                <label class="font-weight-bold w-100 "><u>SE CONSULTARÁ LA SIGUIENTE INFORMACIÓN</u></label>
                <div class="w-100 d-flex">
                  <div class="w-75">
                    <label class="smallTitle">{{ 'TRAMITE.FORM.LABEL.DNI_NIE' | translate }}</label>
                  </div>
                </div>

                <div class="w-100 d-flex">
                  <div class="w-75">
                    <label class="smallTitle">{{ 'TRAMITE.FORM.LABEL.CERTIFICADO_DEL_IRPF_O_CERTIFICADO_DE_IMPUTACIONES_Y_O_PENSIONES_PUBLICAS_EXENTA' | translate }}</label>
                  </div>
                </div>

                <div class="w-100 d-flex">
                  <div class="w-75">
                    <label class="smallTitle">{{ 'TRAMITE.FORM.LABEL.PRESTACIONES_SOCIALES_PUBLICAS_INCAPACIDAD_TEMPORAL_Y_MATERNIDAD' | translate }}</label>
                  </div>
                </div>

                <div class="w-100 d-flex">
                  <div class="w-75">
                    <label class="smallTitle">{{ 'TRAMITE.FORM.LABEL.FAMILIA_NUMEROSA' | translate }}</label>
                  </div>
                </div>

                <div class="w-100 d-flex">
                  <div class="w-75">
                    <label class="smallTitle">{{ 'TRAMITE.FORM.LABEL.DISCAPACIDAD_Y_O_DEPENDENCIA' | translate }}</label>
                  </div>
                </div>

                <div class="w-100 d-flex">
                  <div class="w-75">
                    <label class="smallTitle">{{ 'TRAMITE.FORM.LABEL.TITULARIDAD_INMUEBLES_Y_O_NOTA_SIMPLE' | translate }}</label>
                  </div>
                </div>

                <div class="w-100 d-flex">
                  <div class="w-75">
                    <label class="smallTitle">{{ 'TRAMITE.FORM.LABEL.EMPADRONAMIENTO' | translate }}</label>
                  </div>
                </div>
              </div>
              <div class="row  p-2">
                <label class="font-weight-bold w-100 "><u>Cláusula de Privacidad</u></label>
                <p class="smallInfo">
                  De conformidad con el Reglamento (UE) 2016/679 de 27 de abril de 2016, relativo a la protección de las 
                  personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos 
                  datos, y la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los 
                  derechos digitales, la EMVS, como responsable de sus datos personales, le informa que los datos serán 
                  recabados con la finalidad de consultar sus datos personales con las administraciones y organismos públicos 
                  correspondientes, en el marco de la gestión del tratamiento. La base jurídica que legitima el tratamiento 
                  es el consentimiento de la persona interesada.

                  <br />La EMVS podrá comunicar sus datos personales a administraciones y organismos públicos 
                  competentes para la gestión del tratamiento. No se realizarán transferencias internacionales ni se 
                  adoptarán decisiones basadas únicamente en el tratamiento automatizado de los datos personales.

                  <br />Los datos personales solicitados para esta actividad serán conservados durante el tiempo 
                  necesario para gestionar la finalidad para la que han sido recabados y, en todo caso, hasta que hayan 
                  prescrito los plazos para interponer cualquier acción civil, penal o administrativa relacionada con el 
                  tratamiento.

                  <br />En cualquier momento, el titular podrá ejercer sus derechos de acceso, rectificación, supresión, 
                  limitación, portabilidad u oposición, personándose en nuestras oficinas o dirigiéndose por escrito 
                  a la EMVS, ya sea por correo postal, a través del Portal de la Oficina Virtual (<a
                    class="icons-tramite font-weight-bold" href="https://oficinavirtual.emvs.es/#/"
                    target="_blank">https://oficinavirtual.emvs.es/#/</a>), o mediante correo electrónico a
                  proteccion.datos&#64;emvs.es, debiendo acreditar su identidad con el correspondiente documento
                  acreditativo.

                  <br />También podrá contactar con el Delegado de Protección de Datos a través del correo electrónico
                  dpd&#64;emvs.es. En caso de no obtener la respuesta deseada, podrá presentar una reclamación ante la
                  Agencia Española de Protección de Datos (AEPD) en www.aepd.es

                  <br />La información ampliada sobre protección de datos está disponible en el siguiente enlace: <a
                    class="icons-tramite font-weight-bold"
                    href="https://www.emvs.es/terminos-y-condiciones/autorizacion-de-consulta"
                    target="_blank">https://www.emvs.es/terminos-y-condiciones/autorizacion-de-consulta</a>
                </p>
              </div>
              <div class="col-sm-12">
                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                  <button type="button" [disabled]="uploadDocuments" class="btn btn-danger mt-2 mr-2"
                    (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                  <button type="button" [disabled]="uploadDocuments" class="btn btn-primary mt-2 mr-2"
                    (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>
                  <fieldset>
                    <boton-listado>
                    </boton-listado>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
          <div class="tab-pane fade" id="consulta" role="tabpanel" aria-labelledby="consulta-tab">
            <form [formGroup]="formDeclaracionResponsable" (ngSubmit)="onSubmitConsulta()">
              <h3 class="tabtitle">{{ 'TRAMITE.TITLES.RESPONSIBLE_DECLARATION' | translate }}</h3>
              <div class="col-sm-12 p-2">
                <p>En calidad de solicitante <strong>{{ 'TRAMITE.CONTENT.DECLARO_BAJO_MI_RESPONSABILIDAD' | translate }}</strong>,
                  que todas las personas de la unidad familiar reúnen los requisitos exigidos para participar
                  en la adjudicación de las viviendas de la Promoción Iberia Loreto 01, garantizando asimismo
                  la veracidad de los datos expresados en la solicitud, poniendo a disposición de EMVS Madrid
                  la documentación cuando me sea requerida para la comprobación de los requisitos, así como
                  para el visado del contrato.
                </p>
              </div>
              <div class="col-sm-12 mt-2">
                <div class="row">
                  <p class="font-weight-bold">{{ 'TRAMITE.CONTENT.CONOZCO_QUE_LA_INEXACTITUD_FALSEDAD_U_OMISION_DE_CARACTER_ESENCIAL_DE_CUALQUIER_' | translate }}</p>
                  <label class="font-weight-bold w-100 mt-2"><u>Cláusula de Privacidad</u></label>
                  <p>De conformidad con el Reglamento (UE) 2016/679, de 27 de abril, y la Ley Orgánica 3/2018, de 5 
                    de diciembre, la Empresa Municipal de la Vivienda y Suelo de Madrid, como responsable del tratamiento, 
                    le informa de que los datos personales facilitados serán tratados con la finalidad de gestionar su 
                    solicitud de participación en el procedimiento de adjudicación de viviendas correspondiente al 
                    Programa de Vivienda para Jóvenes y Familias Madrileñas de la promoción Iberia Loreto 01, verificar 
                    el cumplimiento de los requisitos exigidos, realizar las comprobaciones administrativas oportunas y 
                    proceder, en su caso, a la adjudicación y formalización del contrato de arrendamiento de las viviendas 
                    gestionadas por EMVS Madrid. La base legitimadora del tratamiento es el consentimiento de la persona 
                    interesada y el cumplimiento de una misión realizada en interés público.

                    <br />EMVS podrá ceder sus datos personales a otras administraciones públicas, organismos competentes 
                    o terceros autorizados cuando sea necesario para la tramitación, comprobación y gestión de su solicitud, 
                    así como para el posterior visado del contrato por la Comunidad de Madrid. No se realizarán transferencias 
                    internacionales, ni se adoptarán decisiones basadas únicamente en el tratamiento automatizo de los datos 
                    personales de las personas solicitantes. 

                    <br />Los datos personales se conservarán durante el tiempo necesario para gestionar y tramitar su solicitud 
                    y participación en el procedimiento de adjudicación. En caso de no resultar adjudicatario o de exclusión del 
                    procedimiento, los datos se conservarán durante el plazo necesario para atender posibles reclamaciones o recursos. 
                    En caso de resultar adjudicatario, los datos se conservarán mientras se mantenga la relación contractual y durante 
                    los plazos legalmente establecidos para atender posibles responsabilidades legales, administrativas o contractuales 
                    derivadas del tratamiento.

                    <br />En cualquier momento, la persona interesada puede ejercer sus derechos de acceso, rectificación, supresión, 
                    oposición, limitación del tratamiento y portabilidad, presentándose en nuestras oficinas o mediante escrito dirigido 
                    a EMVS Madrid, ya sea por correo postal, a través del Portal de la Oficina Virtual(<a class="icons-tramite font-weight-bold"
                      href="https://oficinavirtual.emvs.es/#/" target="_blank">https://oficinavirtual.emvs.es/#/</a>), o
                    mediante correo electrónico a proteccion.datos&#64;emvs.es, acreditando debidamente su identidad.

                    <br />Puede contactar con el Delegado de Protección de Datos a través del correo electrónico
                    dpd&#64;emvs.es. Asimismo, si considera que sus derechos no han sido debidamente atendidos, 
                    puede presentar una reclamación ante la Agencia Española de Protección de Datos en AEPD.

                    <br />La información ampliada sobre protección de datos está disponible en la página web de EMVS Madrid.
                  </p>
                </div>
                <div class="pl-3 row">
                  <label class="form-check-label font-weight-bold"><input class="form-check-input position-static"
                      type="checkbox" formControlName="declaracion" id="declaracion" [value]="" />
                    He leído y acepto</label>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="d-grid gap-2 d-md-flex justify-content-md-end row">
                  <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                  <button type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>
                  <!-- <button [disabled]="submitConsulta" type="submit" class="btn btn-primary mt-2">{{ 'TRAMITE.CONTENT.FINALIZAR' | translate }}</button>-->
                  <button type="submit" class="btn btn-primary mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                </div>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
  </div>
  <form id="firma" (submit)="resultchange($event)" class="">
    <input type="hidden" id="result" />
    <input type="hidden" id="error" />
    <input type="hidden" id="certifcado" />
  </form>

    <div class="modal fade show" id="modalABorradoTramite" tabindex="-1" aria-labelledby="modalABorradoTramiteLabel" [attr.aria-hidden]="displayFirma === 'none'"
      [ngStyle]="{'display':displayFirma}">
      <div class="modal-dialog">
          <div class="modal-content">
              <div class="modal-header">
                  <h5>{{ 'TRAMITE_LIST.SIGN.TITLE' | translate }}</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                      (click)="closeModalFirma()">
                      <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <div class="modal-body">
                  <h6>{{ 'TRAMITE.SIGN.METHOD' | translate }}</h6>
              </div>
              <div class="modal-footer">
                  <fieldset [disabled]="actionProgres" [class]="isInProgress?'activated':'not-activated'">
                      <boton-listado>
                      </boton-listado>
                  </fieldset>
              </div>
          </div>
      </div>
  </div> 
  <div class="modal fade show" id="modalAvisoFirmas" tabindex="-1" aria-labelledby="modalAvisoFirmasLabel"
    aria-hidden="true" [ngStyle]="{'display':displayAvisoFirma}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5>{{ 'CONFIRM_EMAIL.WARNING.TITLE' | translate }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
            (click)="displayAvisoFirma='none'">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>{{ 'TRAMITE.CONTENT.EN_CASO_DE_NO_AUTORIZAR_A_REALIZAR_LA_CONSULTA_DE_DATOS_DEBERA_APORTAR_TODA_LA_D' | translate }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary mt-2 mr-2" (click)="closeAvisoFirmaModal()">{{ 'TRAMITE.CONTENT.VOLVER_AL_TRAMITE' | translate }}</button>
          <button type="button" class="btn btn-secondary-b mt-2 mr-2" (click)="onSubmitAutorizacion()">{{ 'TRAMITE.CONTENT.CONTINUAR_CON_LA_FIRMA' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>